import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';

export const Section = styled(Box)(({ theme, backgroundColor }) => ({
  color      : theme.palette.primary.white,
  backgroundColor,
  marginTop  : '1px',
  fontFamily : 'Montserrat',
  fontWeight : '900',
  padding    : '1.2rem 0.7rem',
  fontSize   : '22px',
  display    : 'flex',
  alignItem  : 'center',
  cursor     : 'pointer',
  '& svg'    : {
    height     : 'auto',
    marginLeft : '1rem',
    cursor     : 'pointer',
  },
}));

export const WatchVideoBtn = styled(Box)(({ theme }) => ({
  backgroundColor : theme.palette.primary.blue1,
  cursor          : 'pointer',
  fontFamily      : 'Montserrat',
  width           : 'fit-content',
  padding         : '0.5rem 0.8rem',
  color           : theme.palette.primary.white,
  fontSize        : '14px',
}));

export const QuestionsLabel = styled(Typography)(({ theme }) => ({
  marginTop  : '20px',
  fontFamily : 'Montserrat',
  fontWeight : '900',
  color      : theme.palette.primary.blue1,
}));

export const PKDImg = styled('img')({
  display : 'block',
  margin  : '30px auto',
});
